import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { RootState } from 'app/AppStore';
import { useIsDHCatalogSourceInUrl } from 'domains/catalog/Catalog.utils';
import { getLatestInStockReference } from 'domains/references/References.store';
import { Product } from 'pages/CatalogPage/DH/Product';
import { SeePlateLink } from 'pages/CatalogPage/DH/SubcategorySection/SparePartsSection/ReferenceCardsContainer/ReferenceCard/SeePlateLink';
import { Modal } from 'UI';
import { useBreakpointSelectorFull } from 'utils';

interface ProductModalProps {
  triggerComponent: React.ReactNode;
  referenceNumber: string;
  seePlate?: React.ReactNode;
  isVehicleCatalog?: boolean;
  scrollToSubstitutes?: boolean;
  id?: string;
  isUniversalProduct?: boolean;
  isCrossSellReference?: boolean;
}

const SModal = styled(Modal)`
  .ant-modal-body {
    padding: 0 0 30px 0;
  }
`;

const ProductModal = ({
  triggerComponent,
  referenceNumber,
  scrollToSubstitutes,
  isVehicleCatalog,
  id,
  isUniversalProduct,
  isCrossSellReference,
}: ProductModalProps) => {
  const [showModal, setShowModal] = useState(false);
  const isDHCatalogSourceInUrl = useIsDHCatalogSourceInUrl();
  const seePlateState = useState<string | undefined>(undefined);

  const handleChangeShowModal = () => {
    setShowModal((prev) => !prev);
  };

  const breakpointSelectorFull = useBreakpointSelectorFull();
  const toLeft = breakpointSelectorFull({
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: true,
    xml: true,
    xxl: true,
  });

  // Always use getLatestInStockReference to ensure correct supersession display
  const latestInStockReference = useSelector((state: RootState) => getLatestInStockReference(state, referenceNumber));
  const seePlateComp = (
    <>
      {isDHCatalogSourceInUrl && (
        <SeePlateLink
          referenceNumber={latestInStockReference}
          seePlateState={seePlateState}
          fromDetail={toLeft}
          onClick={() => {
            setShowModal(false);
          }}
        />
      )}
    </>
  );

  return (
    <>
      <div onClick={handleChangeShowModal} key={id}>
        {triggerComponent}
      </div>
      <SModal
        open={showModal}
        footer={''}
        onCancel={() => setShowModal(false)}
        width={'80%'}
        zIndex={1000}
        key={`modal-${id}`}
        getContainer={document.body}
      >
        <Product
          referenceNumber={latestInStockReference}
          isPopin
          seePlate={seePlateComp}
          scrollToSubstitutes={scrollToSubstitutes}
          isVehicleCatalog={isVehicleCatalog}
          isUniversalProduct={isUniversalProduct}
          isCrossSellReference={isCrossSellReference}
        />
      </SModal>
    </>
  );
};

export default ProductModal;
